////////LIBRARY/////////
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
///////COMPONENTS///////
import Dialog from 'material-ui/Dialog'
import { apiDeleteCarrier, apiGetMyCarriersData } from '../../../actions/myCarriers'
import ActionHelper from '../ColumnHelpers/ActionHelper'
import MenuItem from 'material-ui/MenuItem'
import theme from '../../styledComponents/theme'
import * as SC from '../../styledComponents'
/////////ASSETS/////////
import Edit from 'material-ui/svg-icons/image/edit'
import Cancel from 'material-ui/svg-icons/navigation/cancel'
import router from 'react-router/lib/Router'

class DeliveryFllowUpActions extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openAwbModal: false,
      openDeleteModal: false,
      isModalOpened: false

    }
  }

	///////////////////////////////// HANDLE ///////////////////////////////////////

  handleOpenDeleteModal = () => {
    this.setState({ openDeleteModal: true, isModalOpened: true })
  }

  handleCloseDeleteModal = () => {
    this.setState({ openDeleteModal: false, isModalOpened: false })
  }

  handleConfirmDelete = () => {
    const { router } = this.context

    const { row: { iD_Mode_Livraison, iD_Societe } } = this.props
    this.props.apiDeleteCarrier({ iDSociete: iD_Societe, idCarrier: iD_Mode_Livraison }).then(()=> this.props.apiGetMyCarriersData({ iDSociete: this.props.iDSociete }))
    this.setState({ openDeleteModal: false })
  }

  ///////////////////////////////// RENDER ///////////////////////////////////////

  render() {
    const { row, trl, handleOpenEdit } = this.props

    const actionsCancel = [
      <SC.ButtonR_S style={{ margin: "0 20px" }} onClick={this.handleCloseDeleteModal}>
        {trl.myaddresses_modal_btn_Cancel}
      </SC.ButtonR_S>,
      <SC.ButtonPA_S onClick={this.handleConfirmDelete}>
        {trl.myCarriers_table_actions__confirm}
      </SC.ButtonPA_S>
    ]

    return (
      <div>
        <ActionHelper isModalOpened={this.state.isModalOpened}>
          <MenuItem
            style={{ fontSize: theme.font.fontSize }}
            primaryText={trl.mycarriers_tableAction_Edit}
            leftIcon={<Edit />}
            onClick={() => handleOpenEdit(row)}
          />
          <MenuItem
            style={{ fontSize: theme.font.fontSize }}
            primaryText={trl.mycarriers_tableAction_Delete}
            leftIcon={<Cancel />}
            onClick={() => this.handleOpenDeleteModal()}
          />
        </ActionHelper>
        <Dialog
          title={trl.mycarriers_tableAction_Delete}
          actions={actionsCancel}
          modal={false}
          open={this.state.openDeleteModal}
        >
          <p>{trl.common__actionsConfirm}</p>
        </Dialog>
      </div>
    )
  }
}

DeliveryFllowUpActions.contextTypes = {
  store: React.PropTypes.object.isRequired
}

DeliveryFllowUpActions.propTypes = {
  row: PropTypes.object.isRequired
}

const mapStateToProps = ({ languages, me, delivery }) => ({
  trl: languages.siteLanguage.keys,
  company_type: me.company_type,
  additional: delivery.additional,
  errors: delivery.errors,
  iDSociete: me.iD_Societe,
})
export default connect(
  mapStateToProps,
  { apiDeleteCarrier, apiGetMyCarriersData }
)(DeliveryFllowUpActions)
